/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as BillingRouteImport } from './routes/billing'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as AgentsIndexRouteImport } from './routes/agents/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as ProjectsNewRouteImport } from './routes/projects/new'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as IntegrationsMcpRouteImport } from './routes/integrations.mcp'
import { Route as EditorProjectIdRouteImport } from './routes/editor/$projectId'
import { Route as AuthCallbackRouteImport } from './routes/auth/callback'
import { Route as AgentsNewRouteImport } from './routes/agents/new'
import { Route as AgentsAgentIdRouteImport } from './routes/agents/$agentId'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminPlansRouteImport } from './routes/admin/plans'
import { Route as AdminPaymentsRouteImport } from './routes/admin/payments'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AdminConnectorsRouteImport } from './routes/admin/connectors'
import { Route as AdminAiHubRouteImport } from './routes/admin/ai-hub'
import { Route as AdminAiConfigRouteImport } from './routes/admin/ai-config'
import { Route as AdminAgentsRouteImport } from './routes/admin/agents'
import { Route as AdminPlansPlanIdRouteImport } from './routes/admin/plans_.$planId'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const BillingRoute = BillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsIndexRoute = AgentsIndexRouteImport.update({
  id: '/agents/',
  path: '/agents/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsNewRoute = ProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsMcpRoute = IntegrationsMcpRouteImport.update({
  id: '/integrations/mcp',
  path: '/integrations/mcp',
  getParentRoute: () => rootRouteImport,
} as any)
const EditorProjectIdRoute = EditorProjectIdRouteImport.update({
  id: '/editor/$projectId',
  path: '/editor/$projectId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/editor/$projectId.lazy').then((d) => d.Route),
)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsNewRoute = AgentsNewRouteImport.update({
  id: '/agents/new',
  path: '/agents/new',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsAgentIdRoute = AgentsAgentIdRouteImport.update({
  id: '/agents/$agentId',
  path: '/agents/$agentId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/admin/settings',
  path: '/admin/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPlansRoute = AdminPlansRouteImport.update({
  id: '/admin/plans',
  path: '/admin/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPaymentsRoute = AdminPaymentsRouteImport.update({
  id: '/admin/payments',
  path: '/admin/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/admin/dashboard',
  path: '/admin/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminConnectorsRoute = AdminConnectorsRouteImport.update({
  id: '/admin/connectors',
  path: '/admin/connectors',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAiHubRoute = AdminAiHubRouteImport.update({
  id: '/admin/ai-hub',
  path: '/admin/ai-hub',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAiConfigRoute = AdminAiConfigRouteImport.update({
  id: '/admin/ai-config',
  path: '/admin/ai-config',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAgentsRoute = AdminAgentsRouteImport.update({
  id: '/admin/agents',
  path: '/admin/agents',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminPlansPlanIdRoute = AdminPlansPlanIdRouteImport.update({
  id: '/admin/plans_/$planId',
  path: '/admin/plans/$planId',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/billing': typeof BillingRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/settings': typeof SettingsRoute
  '/admin/agents': typeof AdminAgentsRoute
  '/admin/ai-config': typeof AdminAiConfigRoute
  '/admin/ai-hub': typeof AdminAiHubRoute
  '/admin/connectors': typeof AdminConnectorsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/agents/new': typeof AgentsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/integrations/mcp': typeof IntegrationsMcpRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/admin': typeof AdminIndexRoute
  '/agents': typeof AgentsIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/admin/plans/$planId': typeof AdminPlansPlanIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/billing': typeof BillingRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/settings': typeof SettingsRoute
  '/admin/agents': typeof AdminAgentsRoute
  '/admin/ai-config': typeof AdminAiConfigRoute
  '/admin/ai-hub': typeof AdminAiHubRoute
  '/admin/connectors': typeof AdminConnectorsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/agents/new': typeof AgentsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/integrations/mcp': typeof IntegrationsMcpRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/admin': typeof AdminIndexRoute
  '/agents': typeof AgentsIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/admin/plans/$planId': typeof AdminPlansPlanIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/billing': typeof BillingRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/settings': typeof SettingsRoute
  '/admin/agents': typeof AdminAgentsRoute
  '/admin/ai-config': typeof AdminAiConfigRoute
  '/admin/ai-hub': typeof AdminAiHubRoute
  '/admin/connectors': typeof AdminConnectorsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/payments': typeof AdminPaymentsRoute
  '/admin/plans': typeof AdminPlansRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/users': typeof AdminUsersRoute
  '/agents/$agentId': typeof AgentsAgentIdRoute
  '/agents/new': typeof AgentsNewRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/integrations/mcp': typeof IntegrationsMcpRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/admin/': typeof AdminIndexRoute
  '/agents/': typeof AgentsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/admin/plans_/$planId': typeof AdminPlansPlanIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/billing'
    | '/login'
    | '/register'
    | '/settings'
    | '/admin/agents'
    | '/admin/ai-config'
    | '/admin/ai-hub'
    | '/admin/connectors'
    | '/admin/dashboard'
    | '/admin/payments'
    | '/admin/plans'
    | '/admin/settings'
    | '/admin/users'
    | '/agents/$agentId'
    | '/agents/new'
    | '/auth/callback'
    | '/editor/$projectId'
    | '/integrations/mcp'
    | '/projects/$projectId'
    | '/projects/new'
    | '/admin'
    | '/agents'
    | '/projects'
    | '/admin/plans/$planId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/billing'
    | '/login'
    | '/register'
    | '/settings'
    | '/admin/agents'
    | '/admin/ai-config'
    | '/admin/ai-hub'
    | '/admin/connectors'
    | '/admin/dashboard'
    | '/admin/payments'
    | '/admin/plans'
    | '/admin/settings'
    | '/admin/users'
    | '/agents/$agentId'
    | '/agents/new'
    | '/auth/callback'
    | '/editor/$projectId'
    | '/integrations/mcp'
    | '/projects/$projectId'
    | '/projects/new'
    | '/admin'
    | '/agents'
    | '/projects'
    | '/admin/plans/$planId'
  id:
    | '__root__'
    | '/'
    | '/billing'
    | '/login'
    | '/register'
    | '/settings'
    | '/admin/agents'
    | '/admin/ai-config'
    | '/admin/ai-hub'
    | '/admin/connectors'
    | '/admin/dashboard'
    | '/admin/payments'
    | '/admin/plans'
    | '/admin/settings'
    | '/admin/users'
    | '/agents/$agentId'
    | '/agents/new'
    | '/auth/callback'
    | '/editor/$projectId'
    | '/integrations/mcp'
    | '/projects/$projectId'
    | '/projects/new'
    | '/admin/'
    | '/agents/'
    | '/projects/'
    | '/admin/plans_/$planId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BillingRoute: typeof BillingRoute
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  SettingsRoute: typeof SettingsRoute
  AdminAgentsRoute: typeof AdminAgentsRoute
  AdminAiConfigRoute: typeof AdminAiConfigRoute
  AdminAiHubRoute: typeof AdminAiHubRoute
  AdminConnectorsRoute: typeof AdminConnectorsRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminPaymentsRoute: typeof AdminPaymentsRoute
  AdminPlansRoute: typeof AdminPlansRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AgentsAgentIdRoute: typeof AgentsAgentIdRoute
  AgentsNewRoute: typeof AgentsNewRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  EditorProjectIdRoute: typeof EditorProjectIdRoute
  IntegrationsMcpRoute: typeof IntegrationsMcpRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  ProjectsNewRoute: typeof ProjectsNewRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AgentsIndexRoute: typeof AgentsIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  AdminPlansPlanIdRoute: typeof AdminPlansPlanIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/billing': {
      id: '/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof BillingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/': {
      id: '/agents/'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AgentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/new': {
      id: '/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof ProjectsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations/mcp': {
      id: '/integrations/mcp'
      path: '/integrations/mcp'
      fullPath: '/integrations/mcp'
      preLoaderRoute: typeof IntegrationsMcpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/editor/$projectId': {
      id: '/editor/$projectId'
      path: '/editor/$projectId'
      fullPath: '/editor/$projectId'
      preLoaderRoute: typeof EditorProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/new': {
      id: '/agents/new'
      path: '/agents/new'
      fullPath: '/agents/new'
      preLoaderRoute: typeof AgentsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/$agentId': {
      id: '/agents/$agentId'
      path: '/agents/$agentId'
      fullPath: '/agents/$agentId'
      preLoaderRoute: typeof AgentsAgentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/admin/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/plans': {
      id: '/admin/plans'
      path: '/admin/plans'
      fullPath: '/admin/plans'
      preLoaderRoute: typeof AdminPlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/payments': {
      id: '/admin/payments'
      path: '/admin/payments'
      fullPath: '/admin/payments'
      preLoaderRoute: typeof AdminPaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/admin/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/connectors': {
      id: '/admin/connectors'
      path: '/admin/connectors'
      fullPath: '/admin/connectors'
      preLoaderRoute: typeof AdminConnectorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ai-hub': {
      id: '/admin/ai-hub'
      path: '/admin/ai-hub'
      fullPath: '/admin/ai-hub'
      preLoaderRoute: typeof AdminAiHubRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/ai-config': {
      id: '/admin/ai-config'
      path: '/admin/ai-config'
      fullPath: '/admin/ai-config'
      preLoaderRoute: typeof AdminAiConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/agents': {
      id: '/admin/agents'
      path: '/admin/agents'
      fullPath: '/admin/agents'
      preLoaderRoute: typeof AdminAgentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/plans_/$planId': {
      id: '/admin/plans_/$planId'
      path: '/admin/plans/$planId'
      fullPath: '/admin/plans/$planId'
      preLoaderRoute: typeof AdminPlansPlanIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BillingRoute: BillingRoute,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  SettingsRoute: SettingsRoute,
  AdminAgentsRoute: AdminAgentsRoute,
  AdminAiConfigRoute: AdminAiConfigRoute,
  AdminAiHubRoute: AdminAiHubRoute,
  AdminConnectorsRoute: AdminConnectorsRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminPaymentsRoute: AdminPaymentsRoute,
  AdminPlansRoute: AdminPlansRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminUsersRoute: AdminUsersRoute,
  AgentsAgentIdRoute: AgentsAgentIdRoute,
  AgentsNewRoute: AgentsNewRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  EditorProjectIdRoute: EditorProjectIdRoute,
  IntegrationsMcpRoute: IntegrationsMcpRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  ProjectsNewRoute: ProjectsNewRoute,
  AdminIndexRoute: AdminIndexRoute,
  AgentsIndexRoute: AgentsIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  AdminPlansPlanIdRoute: AdminPlansPlanIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
